/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Media_Import_Required_TitleInputs */



/**
* | output |
* | --- |
* | "Media Import Required" |
*
* @param {Load_Project_File_Media_Import_Required_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_media_import_required_title = /** @type {((inputs?: Load_Project_File_Media_Import_Required_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Media_Import_Required_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation de media requise")
	if (locale === "de") return /** @type {LocalizedString} */ ("Medienimport erforderlich")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione multimediale richiesta")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Требуется импорт медиафайлов.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se requiere importación de medios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("需要导入媒体文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアのインポートが必要です")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया आयात आवश्यक है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação de mídia necessária")
	return /** @type {LocalizedString} */ ("Media Import Required")
});